import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import InquiryService from "../../../services/inquiryService";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import { Swiper, SwiperSlide } from "swiper/react";
interface Category {
  lable: string;
  value: string | null;
}
const InquiryList: React.FC = () => {
  const { t } = useTranslation();
  const categories: Category[] = [
    { lable: t("All"), value: null },
    { lable: t("Pass"), value: "PASS" },
    { lable: t("Ticket"), value: "TICKET" },
    { lable: t("Tour"), value: "TOUR" },
    { lable: t("Musical"), value: "MUSICAL" },
    { lable: t("E-sim"), value: "SIM" },
    { lable: t("Cancel/ refund policy"), value: "CANCEL" },
    { lable: t("Upgrade process"), value: "UPGRADE" },
  ];
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const fetchCalled = useRef(false);
  const navigate = useNavigate();
  const { isAuthenticated, setShowLoginModal, showLoginModal } = useAuth();
  useEffect(() => {
    if (fetchCalled.current) return; // Skip if already called
    fetchCalled.current = true;
  }, []);

  const formatDate = (dateString: string | null) => {
    if (!dateString) return ""; // Handle null or invalid dates
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    return `${year}.${month}.${day}`;
  };

  const {
    data: inquiries,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["inquiry", selectedCategory, isAuthenticated],
    queryFn: () => InquiryService.getInquiries(selectedCategory),
    enabled: isAuthenticated && !showLoginModal,
    retry: false,
  });

  const handleCategoryClick = (categoryId: string | null) => {
    setSelectedCategory(categoryId);
  };

  const handleRowClick = (id: string) => {
    navigate(`/detail-inquiry/${id}`);
  };

  const renderCategory = () => (
    <Swiper slidesPerView={"auto"} spaceBetween={12} className="my-8">
      {categories.map((category) => (
        <SwiperSlide className="!w-fit" key={category.value}>
          <button
            key={category.value}
            className={`rounded-[3.125rem] px-[1.0625rem] py-2 text-[0.875rem] font-normal leading-[1.25rem] ${
              selectedCategory === category.value
                ? "bg-black font-semibold text-white"
                : "border border-[#EAEEF3] bg-white"
            }`}
            onClick={() => handleCategoryClick(category.value)}
          >
            {category.lable}
          </button>
        </SwiperSlide>
      ))}
    </Swiper>
  );

  const renderList = () => (
    <div className="w-full cursor-pointer rounded-[0.625rem] border border-[#EBEBEB] p-5">
      {isLoading ? null : isError ? (
        <p>{t("An error occurred while fetching inquiries.")}</p>
      ) : !inquiries || inquiries.length === 0 ? (
        <p>{t("No inquiries found.")}</p>
      ) : (
        <table className="w-full text-base leading-[1.4rem]">
          <thead>
            <tr className="border-b border-[#EBEBEB]">
              <th className="p-5">{t("Title")}</th>
              <th className="p-5">{t("Status")}</th>
              <th className="p-5">{t("Posted Date")}</th>
              <th className="p-5 text-right">{t("Reply Date")}</th>
            </tr>
          </thead>
          <tbody>
            {inquiries?.map((inquiry) => (
              <tr
                key={inquiry.id}
                onClick={() => handleRowClick(inquiry.id)}
                className={`border-b border-[#EBEBEB] ${
                  inquiry.unRead ? "bg-[#DBE7FF]" : ""
                }`}
              >
                <td className="p-5">{inquiry.title}</td>
                <td
                  className={`p-5 text-center ${
                    inquiry.status === "PENDING"
                      ? "text-[#A1A1A1]"
                      : "text-[#007AFF]"
                  }`}
                >
                  {inquiry.status
                    ? inquiry.status === "PENDING"
                      ? t("Pending")
                      : t("Replied")
                    : "N/A"}
                </td>
                <td className="p-5 text-center">
                  {formatDate(inquiry.createdAt)}
                </td>
                <td className="p-5 text-right">
                  {formatDate(inquiry.replyDate)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  return (
    <div className="pb-[11.9375rem]">
      {renderCategory()}
      {isAuthenticated ? (
        renderList()
      ) : (
        <div className="mt-16 text-center">
          <button
            onClick={() => setShowLoginModal(true)}
            className="mb-5 w-[13.75rem] rounded-[3.125rem] bg-[#DBE7FF] py-[1rem] text-center text-base font-semibold leading-[1.25rem] text-[#007AFF]"
          >
            {t("Login")}
          </button>
          <p>{t("You can only check it after the Login")}</p>
        </div>
      )}
    </div>
  );
};

export default InquiryList;
